// Base interface for game states
export interface GameState {
  enter(): void;
  exit(): void;
  update(deltaTime: number): void;
  render(ctx: CanvasRenderingContext2D): void;
}

// State Manager for handling game states (Menu, Play, Pause, GameOver)
export class StateManager {
  private currentState: GameState | null = null;
  private states: Map<string, GameState> = new Map();

  public registerState(name: string, state: GameState): void {
    this.states.set(name, state);
  }

  public changeState(name: string, data?: any): void {
    const newState = this.states.get(name);
    if (!newState) {
      console.error(`State "${name}" not found`);
      return;
    }

    if (this.currentState) {
      this.currentState.exit();
    }

    this.currentState = newState;
    
    // Pass data to the new state if it has enterWithData method
    if (data && typeof (newState as any).enterWithData === 'function') {
      (newState as any).enterWithData(data);
    } else {
      this.currentState.enter();
    }
  }

  public update(deltaTime: number): void {
    if (this.currentState) {
      this.currentState.update(deltaTime);
    }
  }

  public render(ctx: CanvasRenderingContext2D): void {
    if (this.currentState) {
      this.currentState.render(ctx);
    }
  }

  public getCurrentState(): GameState | null {
    return this.currentState;
  }
}
